












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'ProductSkeleton'
})
export default class ProductSkeleton extends Vue {
  @Prop({
    type: Number,
    default: 10
  })
  listNums!: number

//   mounted (): void {}
}
